<button
  [attr.data-active]="active()"
  [attr.data-collapsed]="collapsed()"
  class="group transition-all duration-200 relative hover:bg-base-200"
  [class.border-l-4]="!collapsed()"
  [class.border-transparent]="!collapsed() && !active()"
  [class.bg-primary/10]="active()"
  [class.text-primary!]="active()"
  [class.border-primary!]="active() && !collapsed()">
  <span [class]="icon() + ' size-5! shrink-0'"></span>
  @if (!collapsed()) {
    <div class="text-sm font-medium whitespace-nowrap overflow-hidden">
      <ng-content />
    </div>
  }
</button>
